import React, { useEffect, useState } from 'react';
import DepotController from '../controllers/depot-controller';

/**
 * Simple depot dropdown.
 * - Reads the depot list (filtered server-side: a user assigned to a specific depot only sees that one).
 * - Auto-selects the default depot if no value is set.
 * - Disables the control when the user has only one available depot (locked to their depot).
 */
const DepotSelector = ({ value, onChange, name = 'depotId', error, label = 'Dépôt' }) => {
  const [depots, setDepots] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    DepotController.getAllDepots()
      .then((list) => {
        if (!mounted) return;
        const depotList = Array.isArray(list) ? list : [];
        setDepots(depotList);
        if (!value && depotList.length > 0) {
          const def = depotList.find((d) => d.isDefault) || depotList[0];
          onChange({ target: { name, value: def.id.toString() } });
        }
      })
      .catch((e) => console.error('depots load error', e))
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const locked = depots.length === 1;

  return (
    <div>
      <label htmlFor={name} className="block text-sm font-medium text-gray-700 mb-1">
        {label} {locked && <span className="text-xs text-gray-400">(verrouillé)</span>}
      </label>
      <select
        id={name}
        name={name}
        value={value || ''}
        onChange={onChange}
        disabled={loading || locked}
        className={`pl-3 py-3 shadow-sm block w-full border-0 border-b-2 border-gray-200 focus:ring-0 focus:border-[#174540] transition-all duration-300 ease-in-out text-sm rounded-t-md bg-gray-50 ${error ? 'border-red-300 text-red-900' : ''}`}
      >
        <option value="">{loading ? 'Chargement...' : 'Sélectionner un dépôt'}</option>
        {depots.map((d) => (
          <option key={d.id} value={d.id}>
            {d.name}{d.isDefault ? ' (par défaut)' : ''}
          </option>
        ))}
      </select>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
    </div>
  );
};

export default DepotSelector;
